import axios, { AxiosInstance, CreateAxiosDefaults } from "axios";
import Apm from "@/utils/Apm";
import { getTransacaoId } from "@/utils/transacaoContext";
import { classifyError } from "@/utils/apmErrorClassifier";

export const createApiClient = (config: CreateAxiosDefaults): AxiosInstance => {
    const client = axios.create(config);

    client.interceptors.request.use((requestConfig) => {
        const id_transacao = requestConfig.data?.id_transacao || getTransacaoId();

        if (id_transacao) {
            requestConfig.headers = requestConfig.headers || {} as any;
            requestConfig.headers['x-transacao-id'] = id_transacao;
            Apm.addLabels({ id_transacao });
        }

        return requestConfig;
    });

    client.interceptors.response.use(
        (response) => response,
        (error) => {
            const labels = classifyError(error);
            if (Object.keys(labels).length) {
                Apm.addLabels(labels);
            }
            Apm.captureError(error);
            return Promise.reject(error);
        }
    );

    return client;
};
